export const BASE_CLASS_NAME = 'container';

export const getClassName = (name: string) => `${BASE_CLASS_NAME}__${name}`;
